function handle_app_dropdown_states() {
  document.querySelectorAll('.app-dropdowns').forEach((dropdown) => {
    const target_id = dropdown.getAttribute('data-bs-target');
    const target = document.querySelector(target_id);
    if (target) {
      target.addEventListener('shown.bs.collapse', (e) => {
        localStorage.setItem('coll_' + e.target.id, true);
      });
      target.addEventListener('hidden.bs.collapse', (e) => {
        localStorage.removeItem('coll_' + e.target.id);
      });
      if (localStorage.getItem('coll_' + target.id) === 'true') {
        target.classList.add('show');
        dropdown.setAttribute('aria-expanded', 'true');
      } else {
        target.classList.add('hide');
      }
    }
  });
}

function handle_sidebar_state() {
  const sidebar = document.getElementById('sidebar-main');
  if (!sidebar) {
    return;
  }

  // sidebar was recorded as opened or closed from previous page user was on. Default to true if no data.
  const sidebar_opened = localStorage.getItem('sidebar_opened') || 'true';
  if (sidebar_opened === 'true') {
    sidebar.classList.add('show');
  } else if (sidebar_opened === 'false') {
    sidebar.classList.add('hide');
  }

  sidebar.addEventListener('hidden.bs.collapse', (event) => {
    /**
     * event.target check prevents submenus in the sidebar from closing the main sidebar
     * since they also can have the hidden.bs.collapse event.
     */
    if (event.target === sidebar) {
      localStorage.setItem('sidebar_opened', 'false');
      sidebar.classList.add('hide');
    }
  });

  sidebar.addEventListener('shown.bs.collapse', (event) => {
    if (event.target === sidebar) {
      localStorage.setItem('sidebar_opened', 'true');
      sidebar.classList.add('show');
    }
  });

  const last_scroll_pos = Number(localStorage.getItem('sidebar_scroll_pos')) || 0;
  sidebar.scrollTop = last_scroll_pos;

  let debounceTimeout;
  sidebar.addEventListener('scroll', () => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      localStorage.setItem('sidebar_scroll_pos', String(sidebar.scrollTop));
    }, 100);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  if (!document.getElementById('data-profile')) {
    localStorage.removeItem('sidebar');
  }

  handle_app_dropdown_states();
  handle_sidebar_state();
});
